/**
 * Service de facturas (factoring).
 *
 * Thin wrappers sobre API.factoring.* — preservan exactamente la signature del
 * cliente axios original. Cuando se reescriba el axios client (commit posterior
 * o nuevo SaaS), cambiar SOLO la implementación de estas funciones.
 */

import API from "@/api";

export const listarFacturasCargadas = (empresaId: number | string) =>
	(API as any).factoring.listarFacturasCargadas(empresaId);

export const listarFacturasCargadasFiltradas = (empresaId: number | string) =>
	(API as any).factoring.listarFacturasCargadasFiltradas(empresaId);

export const listarFacturasDTE = (empresaId: number | string) =>
	(API as any).factoring.listarFacturasDTE(empresaId);

export const listarFacturasConfirming = (empresaId: number | string) =>
	(API as any).factoring.listarFacturasConfirming(empresaId);

export const sincronizarEmitidos = (rutEmpresa: string) =>
	(API as any).factoring.sincronizar_emitidos(rutEmpresa);

export const cargarFactura = (empresaId: number | string, formData: FormData) =>
	(API as any).factoring.cargarFactura(empresaId, formData);

export const factureUploads = (empresaId: number | string, files: File[]) =>
	(API as any).factoring.factureUploads(empresaId, files);

export const facturaSubirPdf = (empresaId: number | string, facturaId: number | string, file: File | Blob) =>
	(API as any).factoring.factura_subir_pdf(empresaId, facturaId, file);

export const actualizarEstadosFactura = (
	empresaId: number | string,
	ids: Array<number | string>,
	estados: Array<number | string>
) =>
	(API as any).factoring.actualizar_estados_factura(empresaId, ids, estados);

export const actualizarFechaVencimiento = (empresaId: number | string, facturas: Array<{ id: number | string; fecha_vencimiento: string }>) =>
	(API as any).factoring.actualizarFechaVencimiento(empresaId, facturas);
